module.exports = __webpack_public_path__ + "prod/1.42.2/img/logistics-chain.679a81ee.png";